import React, { FC, useState, useMemo } from 'react';
import { WidgetProps } from '@wix/yoshi-flow-editor';
import { DailyAgendaActions } from '../actions/actions';
import { DailyAgendaActionsProvider } from '../hooks/useDailyAgendaActions';
import { Widget as WidgetComponent } from './Widget';
import { WidgetViewModelProvider } from '../hooks/useWidgetViewModel';
import { WidgetViewModel } from '../viewModel/viewModel';
import { DatePickerProvider } from '../hooks/useDatePicker';

const Widget: FC<
  WidgetProps<{
    viewModel: WidgetViewModel;
    actions: DailyAgendaActions;
  }>
> = ({ actions, viewModel }) => {
  const [currentDate, setCurrentDate] = useState(
    new Date(viewModel.datePickerViewModel.selectedDate!),
  );
  const contextValue = useMemo(
    () => ({ currentDate, setCurrentDate }),
    [currentDate],
  );

  return (
    <WidgetViewModelProvider value={viewModel}>
      <DailyAgendaActionsProvider value={actions}>
        <DatePickerProvider value={contextValue}>
          <WidgetComponent />
        </DatePickerProvider>
      </DailyAgendaActionsProvider>
    </WidgetViewModelProvider>
  );
};

export default Widget;
